var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VaimoButton',{staticClass:"button--sold-out",attrs:{"variant":_vm.buttonVariant,"additional-data":_vm.price,"label-centered":true,"aria-label":_vm.$t('Sold out'),"disabled":""}},[_vm._v("\n  "+_vm._s(_vm.$t('Sold out'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }